import updatePpf from 'reducers/updatePpf'
import updateHorizontalAngleOfView from 'reducers/updateHorizontalAngleOfView'
import updateVerticalAngleOfView from 'reducers/updateVerticalAngleOfView'
import updateFocalLength from 'reducers/updateFocalLength'
import updateHorizontalFieldOfView from 'reducers/updateHorizontalFieldOfView'
import updateVerticalFieldOfView from 'reducers/updateVerticalFieldOfView'
import updateDistance from 'reducers/updateDistance'
import updateImagerSize from 'reducers/updateImagerSize'
import updateResolutions from 'reducers/updateResolutions'
import updateCameraHeight from 'reducers/updateCameraHeight'
import updateSceneHeight from 'reducers/updateSceneHeight'
import updateTilt from 'reducers/updateTilt'
import updateFovMode from 'reducers/updateFovMode'
import updateName from 'reducers/updateName'
import updateLocked from 'reducers/updateLocked'
import updateLocation from 'reducers/updateLocation'
import updateHeading from 'reducers/updateHeading'
import updateStreetViewUrl from 'reducers/updateStreetViewUrl'
import updateStreetViewActive from 'reducers/updateStreetViewActive'
import updateStreetViewAvailable from 'reducers/updateStreetViewAvailable'
import updateModel from 'reducers/updateModel'
import updateSingleValue from 'helpers/updateSingleValue'

export default function calculatorUpdateHelpers() {
  return {
    updatePpf,
    updateVerticalAngleOfView,
    updateHorizontalAngleOfView,
    updateFocalLength,
    updateHorizontalFieldOfView,
    updateVerticalFieldOfView,
    updateDistance,
    updateImagerSize,
    updateResolutions,
    updateCameraHeight,
    updateSceneHeight,
    updateTilt,
    updateFovMode,
    updateName,
    updateNotes: updateSingleValue('notes'),
    updateLocked,
    updateLocation,
    updateHeading,
    updateBackgroundPosition: updateSingleValue('backgroundPosition'),
    updateSceneName: updateSingleValue('sceneName'),
    updateStreetViewUrl,
    updateStreetViewActive,
    updateStreetViewAvailable,
    updateModel,
    updateUserUploadedSceneUrl: updateSingleValue('userUploadedSceneUrl'),
    updateUserUploadedSceneActive: updateSingleValue('userUploadedSceneActive'),
    updateUserSelectedGeneralScene: updateSingleValue('userSelectedGeneralScene'),
    updatePpfHoverPosition: updateSingleValue('ppfHoverPosition'),
    updateDisplayIrLine: updateSingleValue('displayIrLine'),
    updatePpfNightMode: updateSingleValue('ppfNightMode'),
    updateUserSelectedPpfNightMode: updateSingleValue('userSelectedPpfNightMode'),
    updateDragged: updateSingleValue('dragged'),
    updateColor: updateSingleValue('color')
  }
}



// WEBPACK FOOTER //
// ./src/helpers/calculatorUpdateHelpers.js